const HeroImg = require("../assets/images/hero/hero-1.jpg")
const Parallax75Img = require("../assets/images/parallax/parallax-75.jpg")


export const Images = {
    HeroImg,
    Parallax75Img
}